<template>
  <div class="stage-level-detail pa-3">
    <div class="caption text--secondary">
      {{ selectedObservatory.address }}
    </div>
    <div class="caption text--secondary">
      {{ selectedObservatory.lat }}, {{ selectedObservatory.lng }}
    </div>
    <v-card class="d-flex align-center" flat tile>
      <v-btn-toggle v-model="displayInterval" mandatory dense>
        <v-btn small :value="10">
          10分毎
        </v-btn>
        <v-btn small :value="60">
          時間毎
        </v-btn>
      </v-btn-toggle>
    </v-card>
    <v-simple-table
      v-if="tableData"
      dense
      class="mt-2"
      fixed-header
      :height="isMobile ? 'calc(100dvh - 180px)' : 'calc(100dvh - 130px)'"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">日時</th>
            <th class="text-center">風向</th>
            <th class="text-center">風速</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ts, index) in tableData" :key="index">
            <td>{{ ts.date }}</td>
            <td class="text-center">
              <v-icon
                v-if="ts.direction === 0"
                color="#b9ebfa"
                class="outlined"
                x-small
              >
                mdi-circle
              </v-icon>
              <v-icon
                v-else
                small
                class="outlined"
                :color="getWindColor(ts.speed)"
                :style="
                  `transform: rotate(${(360 / 16) * ts.direction - 180}deg)`
                "
              >
                mdi-navigation
              </v-icon>
            </td>
            <td class="text-right">
              <template v-if="ts.speed === 0">
                なし
              </template>
              <template v-else>
                {{ ts.speed }}
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "WindDetail",
  components: {},
  data() {
    return {
      tableData: null,
      displayInterval: 10
    };
  },
  computed: {
    isMobile() {
      return this.$route.path === "/mobile";
    },
    selectedObservatory() {
      return this.$store.getters.selectedObservatory;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    timeSeries() {
      return this.$store.getters.selectedObservatory.timeSeries;
    }
  },
  watch: {
    selectedObservatory() {
      this.setTableData();
    },
    displayInterval() {
      this.setTableData();
    }
  },
  created() {
    this.setTableData();
  },
  methods: {
    setTableData() {
      const tableData = [];
      const currentDate = moment.utc(this.timeSeries[this.timeSeries.length - 1].date, "YYYY/MM/DD HH:mm")
      this.timeSeries.forEach(ts => {
        const row = {
          date: this.getDate(ts.date),
          direction: ts.direction,
          speed: ts.speed,
        };

        if (this.displayInterval === 10) {
          const diff = currentDate.diff(moment.utc(ts.date, "YYYY/MM/DD HH:mm"), "minute")
          if (diff <= 180) {
            tableData.push(row);
          }
        } else {
          if (ts.date.endsWith("00")) {
            tableData.push(row);
          }
        }
      });
      this.tableData = tableData;
    },
    getDate(date) {
      return moment
          .utc(date, "YYYY/MM/DD HH:mm")
          .local()
          .format("MM/DD HH:mm")
    },
    getWindColor(speed) {
      const value = speed;
      const colors = [
        { color: "#b40068", value: 25 },
        { color: "#f12705", value: 20 },
        { color: "#f49904", value: 15 },
        { color: "#f9f503", value: 10 },
        { color: "#3e42ff", value: 5 },
        { color: "#b9ebfa", value: 0 }
      ];

      let current;
      for (const color of colors) {
        if (color.value <= value) {
          current = color.color;
          break;
        }
      }
      return current;
    },
  }
};
</script>

<style lang="scss" scoped>
.stage-level-detail {
  thead {
    background-color: #addff3;
  }
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
  .std-color {
    width: 16px;
    height: 12px;
    border-bottom: white 3px solid;
  }
  .predict {
    color: blue;
  }
}
</style>
